import React from 'react';
import { Check } from 'lucide-react';
import { Typography, Box, Button, Dialog, DialogContent, DialogActions } from './UIComponents';

const SuccessDialog = ({ open, onClose, type = "assign" }) => {
  const isUpdate = type === "update";
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 2,
          boxShadow: "0px 10px 35px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <Box
          sx={{
            mb: 3,
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#ecfdf5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            animation: "pulse 1.5s ease-in-out",
            "@keyframes pulse": {
              "0%": { transform: "scale(0.8)", opacity: 0 },
              "70%": { transform: "scale(1.1)", opacity: 1 },
              "100%": { transform: "scale(1)", opacity: 1 },
            },
          }}
        >
          <Check size={32} className="text-green-600" />
        </Box>
        <Typography variant="h6" gutterBottom sx={{ color: "#065f46" }}>
          {isUpdate ? "Agent Updated Successfully" : "Agent Assigned Successfully"}
        </Typography>
        <Typography variant="body2" sx={{ color: "#047857" }}>
          {isUpdate
            ? "The lead has been reassigned to the selected agent."
            : "The lead has been assigned to the selected agent."}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #047857 0%, #065f46 100%)",
            },
            px: 4,
            py: 1,
            borderRadius: "8px",
            transition: "all 0.2s ease",
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;